import { lazy } from 'react';
import { createBrowserRouter, useRouteError } from 'react-router-dom';

import ErrorFallback from 'components/@common/Error';

import ProtectedRoute from './protectedRoute';

// useRouteError는 라우터 컨텍스트가 있어야만 호출 가능하므로,
// errorElement 전용 래퍼에서만 사용하고 ErrorFallback에는 prop으로 넘긴다.
const RouteErrorFallback = () => <ErrorFallback error={useRouteError()} />;

const Login = lazy(() => import('pages/Login'));
const Register = lazy(() => import('pages/Register'));
const FindAccounts = lazy(() => import('pages/FindAccounts'));

const Home = lazy(() => import('pages/Home'));
const MyPage = lazy(() => import('pages/MyPage'));

const Guide = lazy(() => import('pages/Guide'));
const GuideDetail = lazy(() => import('pages/Guide/GuideDetail'));

const Notice = lazy(() => import('pages/Notice'));
const NoticeDetail = lazy(() => import('pages/Notice/NoticeDetail'));

const Review = lazy(() => import('pages/Review'));
const ReviewPost = lazy(() => import('pages/Review/ReviewPost'));
const ReviewApply = lazy(() => import('pages/Review/ReviewApply'));

const VisitExperience = lazy(() => import('pages/VisitExperience'));
const WebsiteOutsourcing = lazy(() => import('pages/WebsiteOutsourcing'));
const ViewTabInstagram = lazy(() => import('pages/ViewTabInsta'));

const router = createBrowserRouter([
	{
		path: '/',
		element: <Login />,
		errorElement: <RouteErrorFallback />,
	},
	{
		path: '/login',
		element: <Login />,
		errorElement: <RouteErrorFallback />,
	},
	{
		path: '/register',
		element: <Register />,
		errorElement: <RouteErrorFallback />,
	},
	{
		path: '/find/id',
		element: <FindAccounts />,
		errorElement: <RouteErrorFallback />,
	},
	{
		path: '/find/password',
		element: <FindAccounts />,
		errorElement: <RouteErrorFallback />,
	},
	{
		path: '/error',
		element: <ErrorFallback />,
		errorElement: <RouteErrorFallback />,
	},
	{
		path: '',
		element: <ProtectedRoute />,
		errorElement: <RouteErrorFallback />,
		children: [
			{
				path: '/main',
				element: <Home />,
			},
			{
				path: '/guide',
				element: <Guide />,
			},
			{
				path: '/guide/post/:_id',
				element: <GuideDetail />,
			},
			{
				path: '/notice',
				element: <Notice />,
			},
			{
				path: '/notice/post/:_id',
				element: <NoticeDetail />,
			},
			{
				path: '/mypage',
				element: <MyPage />,
			},
			{
				path: '/review',
				element: <Review />,
			},
			{
				path: '/review/post/:_id',
				element: <ReviewPost />,
			},
			{
				path: '/review/apply',
				element: <ReviewApply />,
			},
			{
				path: '/review/apply/:_id',
				element: <ReviewApply />,
			},
			{
				path: '/visit-experience',
				element: <VisitExperience />,
			},
			{
				path: '/viewtab-instagram',
				element: <ViewTabInstagram />,
			},
			{
				path: '/website-outsourcing',
				element: <WebsiteOutsourcing />,
			},
		],
	},
	{
		// 정의되지 않은 경로: React Router 기본 404 화면 대신 서비스 화면 노출
		path: '*',
		element: <ErrorFallback />,
	},
]);

export default router;
